// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".external[data-v-35e7b186]:after{content:\" ↗\"}\n", ""]);
// Exports
module.exports = exports;
